/*========CHANGE PASSWORD========= */
export const CHANGE_SECURE_CODE_SUCCESS = 'CHANGE_SECURE_CODE_SUCCESS';
export const CHANGE_SECURE_CODE_FAIL    = 'CHANGE_SECURE_CODE_FAIL';

export const TOGGLE_NOTIFY    = 'TOGGLE_NOTIFY';
